export default {
  common: {
    loading: 'Загрузка…',
    error: 'Что-то пошло не так. Попробуйте ещё раз.',
    retry: 'Повторить',
    cancel: 'Отмена',
    save: 'Сохранить',
    done: 'Готово',
    close: 'Закрыть',
    more: 'Показать ещё',
    showAll: 'Показать все',
    nights: 'ночь | ночи | ночей',
    guests: 'гость | гостя | гостей',
    months: 'месяц | месяца | месяцев',
    perNight: 'ночь',
    perMonth: 'месяц',
    total: 'итого',
    bedrooms: 'спальня | спальни | спален',
    beds: 'кровать | кровати | кроватей',
    baths: 'ванная | ванные | ванных',
    new: 'новое',
    reviewsCount: '{n} отзыв | {n} отзыва | {n} отзывов',
  },
  tabs: { explore: 'Поиск', favorites: 'Избранное', trips: 'Поездки', profile: 'Профиль' },
  explore: {
    title: 'Куда поедем?',
    where: 'где',
    wherePlaceholder: 'Город или район',
    when: 'когда',
    anyDates: 'Любые даты',
    who: 'гостей',
    short: 'Посуточно',
    long: 'Надолго',
    search: 'Найти жильё',
    destinations: 'популярные направления',
    stays: 'жильё',
    results: 'Найдено: {n}',
    empty: 'Ничего не нашлось. Попробуйте другие даты или город.',
    filters: 'Фильтры',
    map: 'Карта',
    list: 'Список',
    sort: { recommended: 'Рекомендуем', price_asc: 'Сначала дешевле', price_desc: 'Сначала дороже', rating: 'По рейтингу', newest: 'Новые' },
    priceMax: 'цена до, {currency}',
    bedroomsMin: 'спален',
    propertyType: 'тип жилья',
    apply: 'Показать',
    reset: 'Сбросить',
    listingsIn: '{n} объектов',
  },
  dates: {
    title: 'Даты',
    checkIn: 'заезд',
    checkOut: 'выезд',
    pickCheckIn: 'Выберите дату заезда',
    pickCheckOut: 'Выберите дату выезда',
    clear: 'Сбросить',
    apply: 'Готово',
  },
  listing: {
    hostedBy: 'Хозяин: {name}',
    hostReply: 'Ответ хозяина',
    agency: 'управляющая компания',
    individual: 'частный владелец',
    verified: 'проверен',
    about: 'об этом жилье',
    amenities: 'удобства',
    rules: 'правила дома',
    checkIn: 'Заезд с {time}',
    checkOut: 'Выезд до {time}',
    pets: 'Можно с животными',
    noPets: 'Без животных',
    smoking: 'Можно курить',
    noSmoking: 'Не курить',
    events: 'Можно мероприятия',
    noEvents: 'Без вечеринок',
    children: 'Подходит для детей',
    location: 'расположение',
    locationHint: 'Точный адрес придёт после бронирования.',
    reviews: 'отзывы',
    noReviews: 'Отзывов пока нет',
    cancellation: 'условия отмены',
    availability: 'свободные даты',
    from: 'от',
    reserve: 'Забронировать',
    chooseDates: 'Выберите даты',
    instant: 'Мгновенное бронирование',
    unavailable: 'Даты недоступны',
    longTermNote: 'Помесячная аренда: оплата раз в месяц, депозит {deposit}',
    utilitiesIncluded: 'коммунальные включены',
    idRequired: 'Хозяин принимает гостей с подтверждённым документом',
    minNights: 'Минимум {n} ночей',
    propertyTypes: { apartment: 'Квартира', studio: 'Студия', house: 'Дом', townhouse: 'Таунхаус', villa: 'Вилла', penthouse: 'Пентхаус', room: 'Комната', other: 'Жильё' },
    spaceTypes: { entire: 'целиком', private_room: 'отдельная комната', shared_room: 'общая комната' },
    policies: {
      flexible: 'Гибкие: полный возврат, если отменить не позднее чем за 24 часа до заезда.',
      moderate: 'Умеренные: полный возврат до 5 дней до заезда, позже — 50% стоимости проживания.',
      firm: 'Строгие: полный возврат до 30 дней до заезда, 50% — до 7 дней, позже возврата нет.',
      strict: 'Жёсткие: полный возврат в течение 48 ч после брони (если до заезда 14+ дней), 50% — до 7 дней.',
      long_term: 'Помесячные: полный возврат до 30 дней до заезда, позже первый месяц не возвращается.',
      non_refundable: 'Без возврата: после брони деньги за проживание не возвращаются.',
      short_notice: 'Полный возврат до 24 часов до начала, 50% — до 2 часов.',
    },
  },
  checkout: {
    title: 'Бронирование',
    yourTrip: 'ваша поездка',
    dates: 'Даты',
    guests: 'Гости',
    edit: 'Изменить',
    price: 'стоимость',
    accommodation: '{nights} × проживание',
    monthlyStay: 'Проживание, {months} мес.',
    discount: 'Скидка',
    extraGuests: 'Доп. гости',
    cleaning: 'Уборка',
    serviceFee: 'Сервисный сбор',
    deposit: 'Депозит (возвратный)',
    total: 'Итого',
    payNow: 'Оплатить сейчас',
    payOnSite: 'Оплата хозяину при заезде',
    payment: 'способ оплаты',
    payOnline: 'Всё онлайн',
    payOnlineHint: 'Картой сейчас, безопасно через Stripe.',
    payOnsite: 'Предоплата + на месте',
    payOnsiteHint: 'Сейчас — только сервисный сбор, остальное хозяину при заезде.',
    installments: 'график платежей',
    installment: '{n}-й месяц · {date}',
    contact: 'контакты',
    name: 'имя и фамилия',
    phone: 'телефон',
    sharePhone: 'Поделиться номером из Telegram',
    phoneVerified: 'подтверждён',
    phoneFromLogin: 'Хозяин увидит телефон, с которым вы вошли.',
    message: 'сообщение хозяину',
    messagePlaceholder: 'Во сколько приедете, с кем путешествуете',
    policy: 'условия отмены',
    agree: 'Нажимая «Оплатить», вы соглашаетесь с правилами дома и условиями отмены.',
    confirmPay: 'Оплатить {amount}',
    idRequired: 'Хозяин принимает только гостей с подтверждённым документом.',
    verifyId: 'Подтвердить документ',
    paymentTitle: 'Оплата',
    holdNote: 'Даты закреплены за вами на {minutes} минут.',
    paying: 'Оплачиваем…',
    stripeMissing: 'Онлайн-оплата не настроена на сервере (STRIPE_PUBLISHABLE_KEY).',
  },
  success: {
    title: 'Готово!',
    waiting: 'Подтверждаем оплату…',
    confirmed: 'Бронь подтверждена. Мы прислали детали в Telegram, а инструкцию по заселению пришлём перед заездом.',
    openTrip: 'Открыть поездку',
  },
  trips: {
    title: 'Поездки',
    upcoming: 'Предстоящие',
    past: 'Прошедшие',
    cancelled: 'Отменённые',
    empty: 'Здесь появятся ваши поездки',
    findStay: 'Найти жильё',
    status: {
      pending_payment: 'ждёт оплаты',
      confirmed: 'подтверждено',
      in_progress: 'проживание',
      completed: 'завершено',
      cancelled_by_guest: 'отменено вами',
      cancelled_by_host: 'отменено хозяином',
      cancelled_by_admin: 'отменено сервисом',
      expired: 'не оплачено',
    },
  },
  trip: {
    code: 'бронь {code}',
    address: 'адрес',
    openMaps: 'Открыть в картах',
    addressAfter: 'Адрес откроется после оплаты.',
    host: 'хозяин',
    call: 'Позвонить',
    checkin: 'заселение',
    guide: 'Инструкция по заселению',
    guideLater: 'Инструкция откроется ближе к заезду — пришлём её и в Telegram.',
    accessCode: 'Код доступа',
    payment: 'оплата',
    paidOnline: 'Оплачено онлайн',
    dueOnsite: 'Оплатить хозяину при заезде',
    payNow: 'Завершить оплату',
    holdExpires: 'Бронь ждёт оплату до {time}',
    installments: 'помесячные платежи',
    payInstallment: 'Оплатить',
    cancel: 'Отменить бронь',
    cancelTitle: 'Отмена брони',
    refund: 'Вернём: {amount}',
    refundNone: 'По условиям отмены возврат не положен.',
    reason: 'Причина (необязательно)',
    cancelConfirm: 'Отменить бронь',
    review: 'Оставить отзыв',
    yourReview: 'Ваш отзыв',
    support: 'Нужна помощь? Написать в поддержку',
    cancelled: 'Бронь отменена',
  },
  review: {
    title: 'Отзыв',
    overall: 'в целом',
    cleanliness: 'чистота',
    accuracy: 'соответствие описанию',
    checkin: 'заселение',
    communication: 'общение',
    location: 'расположение',
    value: 'цена/качество',
    public: 'расскажите другим гостям',
    private: 'личное сообщение хозяину',
    submit: 'Опубликовать',
    doubleBlind: 'Хозяин увидит ваш отзыв, когда оставит свой о вас, или через 14 дней после выезда.',
    thanks: 'Спасибо за отзыв!',
  },
  favorites: { title: 'Избранное', empty: 'Нажмите ♡ на понравившемся жилье — оно появится здесь.' },
  profile: {
    title: 'Профиль',
    guest: 'гость',
    phone: 'телефон',
    notVerified: 'не подтверждён',
    verified: 'подтверждён',
    sharePhone: 'Подтвердить через Telegram',
    identity: 'документ',
    identityVerified: 'подтверждён',
    identityVerify: 'Подтвердить документ',
    identityHint: 'Некоторые хозяева принимают только гостей с проверенным документом. Проверку проводит Stripe, документы не хранятся у нас.',
    notifications: 'уведомления',
    notificationsOn: 'Бот может присылать уведомления',
    notificationsOff: 'Разрешить уведомления от бота',
    language: 'язык',
    name: 'имя',
    lastName: 'фамилия',
    email: 'email',
    support: 'Поддержка',
    host: 'Сдаёте жильё? Приложение для хозяев →',
    login: 'Войти',
  },
  login: {
    title: 'Вход',
    hint: 'Введите номер телефона — пришлём код.',
    phone: 'телефон',
    getCode: 'Получить код',
    code: 'код',
    openTelegram: 'Открыть Telegram, чтобы получить код',
    confirm: 'Войти',
    devCode: 'Dev-режим: код {code}',
  },
  support: {
    title: 'Поддержка',
    topic: 'тема',
    topics: { booking: 'Бронь', payment: 'Оплата', checkin: 'Заселение', account: 'Аккаунт', other: 'Другое' },
    text: 'сообщение',
    send: 'Отправить',
    sent: 'Сообщение отправлено — ответим в Telegram.',
  },
  errors: {
    dates_unavailable: 'Эти даты уже заняты. Выберите другие.',
    payment_unavailable: 'Не удалось начать оплату. Попробуйте позже.',
    too_many_guests: 'Слишком много гостей для этого жилья.',
    min_nights: 'Слишком короткое проживание для этого жилья.',
    max_nights: 'Слишком длинное проживание — выберите помесячную аренду.',
    min_months: 'Минимальный срок помесячной аренды больше выбранного.',
    advance_notice: 'Эти даты слишком близко — хозяин просит бронировать заранее.',
    booking_window: 'Эти даты пока недоступны для брони.',
    identity_verification_required: 'Хозяин принимает только гостей с подтверждённым документом.',
    phone_required: 'Укажите телефон, чтобы хозяин мог с вами связаться.',
    onsite_not_allowed: 'Хозяин принимает только онлайн-оплату.',
    rental_type_unavailable: 'Этот тип аренды здесь недоступен.',
    listing_unavailable: 'Жильё сейчас недоступно для брони.',
    not_cancellable: 'Эту бронь уже нельзя отменить.',
    review_closed: 'Отзыв уже оставлен или срок истёк.',
    guide_not_ready: 'Инструкция откроется ближе к заезду.',
    invalid_code: 'Неверный код.',
    customer_not_verified: 'Этот хозяин принимает только гостей с подтверждённой личностью.',
    nightly_not_available: 'Это жильё сдаётся только помесячно.',
    monthly_not_available: 'Это жильё не сдаётся помесячно.',
    payment_expired: 'Время на оплату вышло. Забронируйте заново.',
    payment_not_configured: 'Оплата и проверка документов ещё не подключены. Напишите в поддержку.',
    channel_unavailable: 'Откройте нашего Telegram-бота, поделитесь там телефоном и запросите код снова.',
    booking_state: 'Эту бронь уже нельзя изменить.',
    throttled: 'Слишком много попыток. Попробуйте через минуту.',
  },
  boot: {
    error: 'Не удалось войти через Telegram. Закройте и снова откройте приложение.',
  },
  // Placeholders: an example of what to type in each field.
  ph: {
    priceMax: '300',
    phone: '+971 50 000 00 00',
    code: '123456',
    supportText: 'Бронь EM12345: код от двери из инструкции не подходит.',
    review: 'Идеально чистая квартира, потрясающий вид и простое заселение. Приедем снова!',
    reviewPrivate: 'Медленно уходит вода в душе — стоит проверить.',
    fullName: 'Анна Смирнова',
    firstName: 'Анна',
    lastName: 'Смирнова',
    email: "anna{'@'}example.com", // a bare @ is vue-i18n linked-message syntax: the production build fails to render the screen
    cancelReason: 'Планы изменились — не сможем приехать в эти даты.',
  },
};
